import { featured } from "@/mocks/homeData";

const blocks = [
  { icon: "ri-user-star-line", t: featured.whoTitle, d: featured.who, tone: "primary" },
  { icon: "ri-question-mark", t: featured.whyTitle, d: featured.why, tone: "accent" },
  { icon: "ri-focus-3-line", t: featured.focusTitle, d: featured.focus, tone: "secondary" },
  { icon: "ri-progress-7-line", t: featured.progressTitle, d: featured.progress, tone: "primary" },
] as const;

export default function Featured() {
  return (
    <section id="focus" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-600">今日焦点 · FOCUS</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              今天这颗瓜，<span className="text-primary-600">一文看懂</span>
            </h2>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-900">
            <i className="ri-fire-fill" aria-hidden="true"></i>今日全网热度 No.1
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="space-y-5 lg:col-span-3">
            <h3 className="font-heading text-xl font-bold leading-relaxed text-foreground-900 md:text-2xl">
              {featured.title}
            </h3>
            <p className="text-sm leading-7 text-foreground-600 md:text-base md:leading-8">{featured.sub}</p>

            <div className="mt-2 space-y-4">
              {blocks.map((b) => (
                <article key={b.t} className="rounded-2xl border border-background-200/70 bg-background-100 p-5">
                  <h4 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
                    <span className={`flex h-8 w-8 items-center justify-center rounded-lg text-background-50 ${b.tone === "accent" ? "bg-accent-500 text-foreground-950" : "bg-primary-600"}`}>
                      <i className={`${b.icon} text-base`} aria-hidden="true"></i>
                    </span>
                    {b.t}
                  </h4>
                  <p className="mt-3 text-sm leading-7 text-foreground-700">{b.d}</p>
                </article>
              ))}
            </div>

            <div className="flex gap-3 rounded-2xl bg-secondary-100 p-4 text-sm leading-6 text-secondary-900">
              <i className="ri-information-line mt-0.5 shrink-0 text-lg" aria-hidden="true"></i>
              <p>{featured.note}</p>
            </div>
          </div>

          <aside className="lg:col-span-2">
            <div className="sticky top-24 overflow-hidden rounded-3xl border border-background-200/70 bg-background-100">
              <div className="relative h-56 md:h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=warm%20variety%20show%20studio%20stage%20with%20amber%20spotlights%20and%20soft%20haze%2C%20empty%20backdrop%2C%20cinematic%20editorial%20magazine%20cover%20lighting%2C%20no%20people%2C%20high%20detail&width=720&height=640&seq=focus-featured-01&orientation=portrait"
                  alt={featured.imageAlt}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-900/40 to-transparent" aria-hidden="true"></div>
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-fire-fill text-accent-300" aria-hidden="true"></i>头号大瓜
                </span>
                <span className="absolute bottom-4 left-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                  截至今日 12:00 更新
                </span>
              </div>
              <div className="p-6">
                <p className="text-xs font-medium tracking-wide text-primary-600">一句话结论</p>
                <p className="mt-2 text-base font-medium leading-7 text-foreground-900">
                  这是一条“讨论热度极高、但至今无实锤”的话题型瓜，本质是观众对节目编排的集体解读。当下最稳妥的做法是<b className="text-primary-700">先看懂、不站队</b>，等一手信息陆续放出。
                </p>
                <a
                  href="#join"
                  className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-800"
                >
                  订阅瓜报，明早第一眼看到进展
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}